import { defineComponent as _defineComponent } from 'vue'
import { Cascader } from 'ant-design-vue'
import city from './city.json'
import { computed } from 'vue'

type Props = {
  /**
   * 可用的层级
   * - 1 只选择省
   * - 2 只选择省市
   * - 3 选择省市区。默认
   *  */
  level?: 1 | 2 | 3
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectPCD',
  props: {
    level: { default: 3 }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { level: 1 | 2 | 3 };



const filterOptions = computed(() => {
  if (props.level === 3) {
    const result = [] as AnyObject[]
    city.forEach((p: AnyObject) => {
      result.push({
        label: p.label,
        value: p.label,
        children: p.children.map((c: AnyObject) => ({
          label: c.label,
          value: c.label,
          children: c.children.map((d: AnyObject) => ({
            label: d.label,
            value: d.label,
            children: undefined,
          })),
        })),
      })
    })
    return result
  }

  if (props.level === 2) {
    const result = [] as AnyObject[]
    city.forEach((p: AnyObject) => {
      result.push({
        label: p.label,
        value: p.label,
        children: p.children.map((c: AnyObject) => ({
          label: c.label,
          value: c.label,
          children: undefined,
        })),
      })
    })
    return result
  }

  if (props.level === 1) {
    const result = [] as AnyObject[]
    city.forEach((p: AnyObject) => {
      result.push({
        label: p.label,
        value: p.label,
        children: undefined,
      })
    })
    return result
  }

  return []
})


function onChange(val: string, selectedOptions: { label: string; value: string }[]) {
  emit('input', val)
  // console.log(1212, val, selectedOptions)
}

return { __sfc: true,props, filterOptions, emit, onChange, Cascader }
}

})